var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html';
var html = "<div class=\"container no-padding\"><div class=\"row no-padding\"><div class=\"col-sm-12 no-padding left\"><h1 class=\"pull-left no-padding\">{{ 'sites.dashboard.widgets.dashboardWidgetCampaignListTitle.haishin_uchi_no' | translate }}</h1><zcs-campaign-create-button class=pull-right project=$ctrl.project></zcs-campaign-create-button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html
// module id = 1408
// module chunks = 0